const routes = {
  login: "auth/login",
  register: "auth/register",
  forgetPassword: "users/forgetPassword",
  resetPassword: "users/resetPassword",
  getSideNavigation: "users/permissions",
  changePassword: "users/changePassword",
  handleLogout: "auth/logout",
  Linking: "auth/link",
  authenticate: "auth/authentication",
  recoveryKey: "auth/recovery-key/login",
  phoneOtp: "auth/phone-otp/login",
};

export default routes;
